module.exports = __webpack_public_path__ + "static/img/img-ptfw1.5f468af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw1.png
// module id = Ezq8
// module chunks = 0